import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { listaccountopeningbalancev2 } from "../../graphql";
import { PURGE } from "redux-persist";

const INITIAL_STATE = {
  data:[]
};

const openingBalanceSlice = createSlice({
  name: "opening_balance",
  initialState: INITIAL_STATE,
  reducers: {
    setAccountOpeningBalance: (state, action) => {
      state.data = action.payload;
    },
    setOpeningBalance: (state, action) => {
      const { accountsid, creditamount, debitamount } = action.payload;
      const index = state.data?.findIndex(
        (account) => account.accountsid === accountsid
      );
     
      if (index !== -1) {
        state.data[index].creditamount = creditamount;
        state.data[index].debitamount = debitamount;
      }
    },


    setDebitOrCredit: (state, action) => {
      const { accountsid, type } = action.payload;
      const index = state.data?.findIndex(
        (account) => account.accountsid === accountsid
      );
      if (index !== -1) {
        state.data[index][type] = 0;
      }
    },

  },
});

export const {
  setAccountOpeningBalance,
  setDebitOrCredit,
  setOpeningBalance
} = openingBalanceSlice.actions;

export default openingBalanceSlice.reducer;
